// converts google geocoder requests to promises

type CallbackedFunction = (...args: any[]) => unknown;

export default function promisify<A extends any[], R>(method: CallbackedFunction) {
  return function promisifedFunction(...args: A): Promise<R> {
    return new Promise((resolve, reject) => {
      method(...args, (...callbackArgs: any[]) => {
        const [status, resultArgs] = callbackArgs.reverse();
        if (status !== 'OK') {
          reject(status);
          return;
        }
        resolve(resultArgs);
      });
    });
  };
}
